import React, { useCallback, useEffect, useState } from "react";
import "./Login.scss";
import { LanguageSelect } from "../../pages/LanguageSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  Grid,
  Icon,
  Input,
  InputLabel,
  Link,
  Select,
  MenuItem,
} from "@material-ui/core";
import {
  useNetworkStatus,
  useTranslations,
  useUrlInfo,
} from "examsbook-react-sdk/custom-hooks";
import i18n from "examsbook-react-sdk/translations";
import { useHistory } from "react-router-dom";
import {
  loginAction,
  microsoftLoginAction,
} from "examsbook-react-sdk/actions/loginAction";
import ReCAPTCHA from "react-google-recaptcha";
import LearnifyIcon from "../../assets/images/LearnifyLogoDark.png";
import { verifyDomainAction } from "examsbook-react-sdk/actions/verifyDomainAction";
import { ColorsConstant } from "../../constants/colorConstant";
import {
  getSettingsAction,
  setSubdomain,
} from "examsbook-react-sdk/actions/getSettingsAction";
import { ReactComponent as MicrosoftIcon } from "../../assets/images/microsoft_logo.svg";
import Cookies from "js-cookie";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
const getCookie = (name) => {
  return Cookies.get(name) || null;
};

const Login = () => {
  const [googleRecaptchaToggle, setGoogleRecaptchaToggle] = useState("");
  const [googleRecaptchaToken, setGoogleRecaptchaToken] = useState(null);
  const [formValues, setFormValues] = useState({ username: "", password: "" });
  const [microsoftLoginSiteKey, setMicrosoftLoginSiteKey] = useState(false);
  const [clientId, setClientId] = useState("");
  const [redirectUri, setRedirectUri] = useState("");
  const [googleRecaptchaSiteKey, setGoogleRecaptchaSiteKey] = useState(null);
  const [bgColor, setBgColor] = useState(null);
  const [textColor, setTextColor] = useState(null);
  const [passwordError, setPasswordError] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [dynamicLogo, setDynamicLogo] = useState(null);
  const [subdomainName, setSubdomainName] = useState("");
  const [showCountryCode, setShowCountryCode] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  const [countryCodes, setCountryCodes] = useState([]);
  const dispatch = useDispatch();
  const t = useTranslations();
  const history = useHistory();

  const language =
    useSelector((state) => state.getLanguaggeReducer.lang) || "en";

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    // Load country codes
    const countries = getCountries();
    const codes = countries.map(code => {
      const callingCode = getCountryCallingCode(code);
      return {
        code: code,
        dialCode: `+${callingCode}`,
        display: `+${callingCode} (${code})`
      };
    }).sort((a, b) => a.dialCode.localeCompare(b.dialCode));
    setCountryCodes(codes);
  }, []);


  const isMobileNumber = (str) => /^\d{10}$/.test(str);
  const containsOnlyNumbers = (str) => /^\d+$/.test(str);
  let inputValue;
  const isOnline = useNetworkStatus();
  const [microsoftLoginError, setMicrosoftLoginError] = useState("");
  const [isCode, isSetCode] = useState(false);
  const [settingsData, setSettingsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { urlSubdomain, currentHost, baseDomain, urlDomain } = useUrlInfo();
  const storedSubdomain = useSelector((state) => state?.subdomainReducer?.subdomain) || getCookie("subdomain")
  const subDomainValue = storedSubdomain ? storedSubdomain : subdomainName;

  useEffect(() => {
    if (
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
    ) {
      const cookieSubdomain = getCookie("subdomain");
      const tokenFromCookie = getCookie("token");
      const token = localStorage.getItem("token") || tokenFromCookie;
      if (cookieSubdomain && token) {
        if (cookieSubdomain !== urlSubdomain) {
          const newUrl = `https://${cookieSubdomain}.${baseDomain}`;
          window.location.href = newUrl;
        } else if (!window.location.pathname.includes("/dashboard")) {
          window.location.href = "/dashboard";
        }
      } else {
        setSubdomainName(null);
        dispatch(setSubdomain(null));
        localStorage.removeItem("subdomain");
      }
    }
  }, [dispatch]);

  const getSettingsApiData = useCallback(async (domain) => {
    try {
      await dispatch(getSettingsAction(domain)).then((res) => {
        setSettingsData(res?.data);
        setIsLoading(true);
      });
    } catch (error) {
      console.error("Error -", error?.data?.message);
      setSubdomainName(null);
      dispatch(setSubdomain(null));
      localStorage.removeItem("subdomain");
      window.location.href = `${window.location.protocol}//${urlDomain}`;
    }
  }, [dispatch, storedSubdomain, urlDomain]);

  useEffect(() => {
    if (subDomainValue) {
      getSettingsApiData(subDomainValue);
    }
  }, [getSettingsApiData, storedSubdomain, subdomainName]);

  useEffect(() => {
    let reason = new URLSearchParams(window.location.search).get("reason");
    if (reason === "deactivated") {
      document.getElementById(
        "deactivate-error"
      ).innerHTML = `<div class="errorMsg">${t("Your account is deactivated, please contact the administrator")}</div>`;
      document.getElementById("deactivate-error").style.display =
        "block";
    }
    else if (reason === "expired") {
      document.getElementById(
        "deactivate-error"
      ).innerHTML = `<div class="errorMsg">${t("Your account is expired, please contact the administrator")}</div>`;
      document.getElementById("deactivate-error").style.display =
        "block";
    }
  }, [])

  const queryParamImpersonate = useCallback(() => {
    let token = new URLSearchParams(window.location.search).get("token");
    let impersonating = "";
    if (token) {
      try {
        const jsonString = atob(token);
        const parsedData = JSON.parse(jsonString);
        token = parsedData.token;
        impersonating = parsedData.impersonating;
        localStorage.setItem("token", token);
        localStorage.setItem("impersonating", impersonating);
        history.push("/dashboard");
        getSettingsApiData(subDomainValue);
      } catch (error) {
        console.log("Error parsing token:", error);
      }
    }
  }, [history]);

  const handleChange = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const getSubdomain = useCallback(() => {
    if (process.env.REACT_APP_TENANT_DOMAIN) {
      setSubdomainName(process.env.REACT_APP_TENANT_DOMAIN);
      dispatch(setSubdomain(process.env.REACT_APP_TENANT_DOMAIN));
    } else if (urlSubdomain) {
      setSubdomainName(urlSubdomain);
      dispatch(setSubdomain(urlSubdomain));
    }
  }, [urlSubdomain, dispatch]);

  useEffect(() => {
    getSubdomain();
    queryParamImpersonate();
  }, [getSubdomain, queryParamImpersonate]);

  const setCookies = (token) => {
    Cookies.set("token", token, {
      path: "/",
      domain: currentHost,
      secure: true,
    });
    Cookies.set("subdomain", urlSubdomain, {
      path: "/",
      domain: currentHost,
      secure: true,
    });
  };

  const verifyDomain = async (info) => {
    try {
      dispatch(verifyDomainAction(info)).then((res) => {
        if (res?.isVerify && res?.url && res.success === "success") {
          Cookies.set("subdomain", info.subdomain, {
            path: "/",
            domain: currentHost,
            secure: true,
          });
          window.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: "SET_SUBDOMAIN",
              payload: info.subdomain,
            })
          );
          window.location.href = res.url;
          // history.push(res.url);
        }
        if (!res) {
          document.getElementById(
            "domain-name-error"
          ).innerHTML = `<div class="errorMsg">${t("Invalid domain")}</div>`;
          document.getElementById("domain-name-error").style.display =
            "block";
          return;
        }
      });
    } catch (error) {
      console.log("Error -", error.message);
      document.getElementById(
        "domain-name-error"
      ).innerHTML = `<div class="errorMsg">${t("An unexpected error occurred. Please try again later.")}</div>`;
      document.getElementById("domain-name-error").style.display = "block";
      return;
    }
  };

  const handleDomainVerify = async (e) => {
    e.preventDefault();
    const { domainname } = formValues;
    const domainVerifyData = {
      subdomain: domainname,
      url: window.location.href,
    };
    await verifyDomain(domainVerifyData);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const { username, password } = formValues;
    const resetPasswordError = document.getElementById("reset-credential-error");

    if (googleRecaptchaToggle && !googleRecaptchaToken) {
      if (resetPasswordError) {
        resetPasswordError.innerHTML = `<div class="errorMsg">${t("Please validate the captcha first.")}</div>`;
        resetPasswordError.style.display = "block";
      }
      return;
    }

    const isMobile = !Number.isNaN(+username);
    
    // Validate country code for mobile login
    if (isMobile && showCountryCode) {
      if (!countryCode) {
        if (resetPasswordError) {
          resetPasswordError.innerHTML = `<div class="errorMsg">${t("Country code is required for mobile login.")}</div>`;
          resetPasswordError.style.display = "block";
        }
        return;
      }
    }

    // Clear previous errors before attempting login
    if (resetPasswordError) {
      resetPasswordError.innerHTML = "";
      resetPasswordError.style.display = "none";
    }

    const loginData = {
      password,
      subdomain: subdomainName,
      [isMobile ? "mobileNumber" : "email"]: username,
      ...(isMobile && { countryCode }),
      ...(googleRecaptchaToggle === true && { captcha: googleRecaptchaToken }),
    };
    try {
      dispatch(loginAction(loginData)).then((res) => {
        if (res?.newPasswordRequired) {
          history.push("/change-password", loginData);
          return;
        }
        if (res?.token) {
          localStorage.setItem("token", res?.token);
          setCookies(res?.token);
          window.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: "SET_TOKEN",
              payload: res?.token,
            })
          );
          history.push("/dashboard");
          return;
        }
        if (res?.status === 400) {
          if (resetPasswordError) {
            resetPasswordError.innerHTML = `<div class="errorMsg">${t(res?.data?.message)}</div>`;
            resetPasswordError.style.display = "block";
          }
          document
            .getElementById("changeCredentialBtn")
            .setAttribute("disabled", "disabled");
          return;
        }
        // Check for "Tenant License Expired" message
        if ((res?.data?.message === "Tenant License Expired" || res?.data?.message === "Tenant License Not Approved") && res?.status === 403) {
          if (resetPasswordError) {
            resetPasswordError.innerHTML = `<div class="errorMsg">${res?.data?.message}</div>`;
            resetPasswordError.style.display = "block";
          }
          return;
        }
      });
    } catch (error) {
      console.log("Error -", error.message);
    }
  };

  useEffect(() => {
    const dynamicLogos =
      settingsData?.data?.[0]?.branding?.logos?.webAndAppLogo?.imagePath;
    setDynamicLogo(dynamicLogos || LearnifyIcon);
    setGoogleRecaptchaToggle(
      settingsData?.data?.[0]
        ? settingsData?.data?.[0]?.integration?.recaptcha?.googleRecaptcha
        : false
    );
    setGoogleRecaptchaSiteKey(
      settingsData?.data?.[0]
        ? settingsData?.data?.[0]?.integration?.recaptcha?.siteKey
        : ""
    );
    setBgColor(
      settingsData?.data?.[0]
        ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme
          ?.primaryBackgroundColor
        : ColorsConstant.defaultBlue
    );
    setTextColor(
      settingsData?.data?.[0]
        ? settingsData?.data?.[0]?.branding?.backgroundAndTextTheme
          ?.primaryTextColor
        : ColorsConstant.white
    );
    setMicrosoftLoginSiteKey(
      settingsData?.data?.[0]?.integration?.singleSignOn?.microsoft
    );
    setClientId(settingsData?.data?.[0]?.integration?.singleSignOn?.clientId);
    setRedirectUri(
      settingsData?.data?.[0]?.integration?.singleSignOn?.redirectUri
    );
  }, [isLoading, settingsData]);

  const handleEmailChange = (event) => {
    inputValue = event.target.value.toLowerCase();
    handleChange("username", inputValue);
    
    // Check if input contains only numbers
    const isNumeric = /^\d+$/.test(inputValue);
    const shouldShowCode = isNumeric && inputValue.length > 0;
    
    if (shouldShowCode !== showCountryCode) {
      setShowCountryCode(shouldShowCode);
      // Maintain focus after state change
      setTimeout(() => {
        document.getElementById("loginEmail")?.focus();
      }, 0);
    }
  };

  const handleEmailBlur = useCallback((event) => {
    const inputValue = event.target.value.trim();

    const isValidEmail = (email) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email.toLowerCase());
    let errMsg = "";
    let emailValid = true;

    if (inputValue) {
      if (containsOnlyNumbers(inputValue)) {
        if (!isMobileNumber(inputValue)) {
          emailValid = false;
          errMsg = t("Enter Valid Mobile Number");
        }
      } else {
        if (!isValidEmail(inputValue)) {
          emailValid = false;
          errMsg = t("Enter Valid Email");
        }
      }
    }

    if (emailValid) {
      document.getElementById("reset-credential-error").style.display = "none";
      document.getElementById("changeCredentialBtn").removeAttribute("disabled");
    } else {
      document.getElementById(
        "reset-credential-error"
      ).innerHTML = `<div class="errorMsg">${errMsg}</div>`;
      document.getElementById("reset-credential-error").style.display = "block";
      document
        .getElementById("changeCredentialBtn")
        .setAttribute("disabled", "disabled");
    }
  }, []);

  // handle autofill scenario
  useEffect(() => {
    const emailInput = document.getElementById("loginEmail");
    if (emailInput) {
      handleEmailBlur({ target: emailInput });
    }
  }, [handleEmailBlur]);

  const handleDomainName = (event) => {
    inputValue = event.target.value;
    handleChange("domainname", inputValue);
  };

  const handleForgotPassword = (event) => {
    event.preventDefault();
    history.push("/forgot-password");
  };

  function base64URLEncode(str) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return base64URLEncode(digest);
  }

  useEffect(() => {
    return () => {
      isSetCode(false);
    };
  }, []);

  const handleMicrosoftCodeExchange = useCallback(
    async (code) => {
      const codeVerifier = localStorage.getItem("pkce_code_verifier");
      const formData = new URLSearchParams({
        client_id: clientId,
        code,
        redirect_uri: redirectUri,
        grant_type: "authorization_code",
        code_verifier: codeVerifier,
      });
      if (!codeVerifier) {
        console.error(
          "Missing PKCE code verifier. Please try logging in again."
        );
        return;
      }
      try {
        if (clientId) {
          const response = await fetch(
            "https://login.microsoftonline.com/common/oauth2/v2.0/token",
            {
              method: "POST",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              body: formData,
            }
          );

          const data = await response.json();
          if (data.access_token) {
            let mobileNumber = null;

            // Fetch user profile to get mobile number
            try {
              const profileResponse = await fetch(
                "https://graph.microsoft.com/v1.0/me",
                {
                  method: "GET",
                  headers: { Authorization: `Bearer ${data.access_token}` },
                }
              );
              const profileData = await profileResponse.json();
              mobileNumber = profileData?.mobilePhone || null;
            } catch (error) {
              console.error("Error fetching mobile number:", error);
            }

            const payload = {
              type: "microsoft",
              accessToken: data.access_token,
              subdomain: subdomainName,
              mobileNumber,
            };
            const res = await dispatch(microsoftLoginAction(payload));
            if (res?.token) {
              localStorage.setItem("token", res.token);
              setCookies(res?.token);
              window.ReactNativeWebView?.postMessage(
                JSON.stringify({
                  type: "SET_TOKEN",
                  payload: res?.token,
                })
              );
              window.location.href = "/dashboard";
            } else if (res?.status === 400 && res?.data?.message) {
              isSetCode(false);
              setMicrosoftLoginError(res?.data?.message);
            } else {
              isSetCode(false);
              setMicrosoftLoginError("Microsoft login failed");
            }
          } else {
            isSetCode(false);
            setMicrosoftLoginError("Failed to get Microsoft access token");
          }
        }
      } catch (error) {
        isSetCode(false);
        setMicrosoftLoginError("Error exchanging code:", error);
      }
    },
    [clientId, redirectUri, subdomainName, dispatch]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    isSetCode(true);
    if (code && clientId !== undefined) {
      handleMicrosoftCodeExchange(code);
    } else {
      isSetCode(false);
    }
  }, [clientId, handleMicrosoftCodeExchange, redirectUri]);

  const handleMicrosoftLogin = async () => {
    const codeVerifier = generateCodeChallenge(64);
    localStorage.setItem("pkce_code_verifier", codeVerifier);
    generateCodeChallenge(codeVerifier).then((codeChallenge) => {
      window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=openid%20profile%20email&code_challenge=${codeChallenge}&code_challenge_method=S256&state=${subdomainName}`;
    });
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("code")) {
      const code = urlParams.get("code");
      const response = await fetch(
        "https://login.microsoftonline.com/common/oauth2/v2.0/token",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: {
            client_id: clientId,
            code,
            redirect_uri: redirectUri,
            grant_type: "authorization_code",
            code_verifier: codeVerifier,
          },
        }
      );
      const data = await response.json();
      dispatch(
        microsoftLoginAction({
          accessToken: data.access_token,
          subdomain: subdomainName,
        })
      ).then((res) => {
        if (res?.token) {
          localStorage.setItem("token", res?.token);
          setCookies(res?.token);
          window.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: "SET_TOKEN",
              payload: res?.token,
            })
          );
          history.push("/dashboard");
        } else {
          setMicrosoftLoginError(res?.data?.message || "Login failed");
        }
      });
    }
  };

  const handlePasswordChange = (event) => {
    let password = event.target.value;
    const pinRegex = /^\d{6}$/;
    const strongPasswordRegex =
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    let errMsg =
      t("Passwords do not match.");
    const captchaContainer = document.getElementById("captchaContainer");
    const loginError = document.getElementById("login-error");
    const loginButton = document.getElementById("login-button");
    handleChange("password", password);
    handleActiveLoginButton(
      formValues.username,
      password,
      googleRecaptchaToken
    );

    let passValid = false;
    if (pinRegex.test(password)) {
      passValid = true;
    } else if (strongPasswordRegex.test(password)) {
      passValid = true;
    }

    if (passValid) {
      document.getElementById("reset-credential-error").style.display = "none";
      document.getElementById("changeCredentialBtn").removeAttribute("disabled");
    } else {
      document.getElementById(
        "reset-credential-error"
      ).innerHTML = `<div class="errorMsg">${errMsg}</div>`;
      document.getElementById("reset-credential-error").style.display = "block";
      document
        .getElementById("changeCredentialBtn")
        .setAttribute("disabled", "disabled");
    }

    if (password === "12345") {
      if (googleRecaptchaToggle && captchaContainer) {
        captchaContainer.style.display = "none";
      }
      setPasswordError("");
      setIsButtonDisabled(false);
    }
    if (pinRegex.test(password) && isMobileNumber(formValues.username)) {
      setPasswordError("");
      setIsButtonDisabled(false);
      document.getElementById("reset-credential-error").style.display = "none";
    } else if (!pinRegex.test(password) && !strongPasswordRegex.test(password)) {
        setPasswordError(errMsg);
        setIsButtonDisabled(true);
      } else {
        if (googleRecaptchaToggle && captchaContainer) {
          captchaContainer.style.display = "block";
        }
        setPasswordError("");
        setIsButtonDisabled(false);
      }

    // Update DOM elements dynamically for non-React-managed attributes
    if (loginError) {
      if (passwordError) {
        loginError.innerHTML = `<div class="errortext">${passwordError}</div>`;
        loginError.style.display = "block";
      } else {
        loginError.style.display = "none";
      }
    }

    if (loginButton) {
      if (isButtonDisabled) {
        loginButton.setAttribute("disabled", "disabled");
      } else {
        loginButton.removeAttribute("disabled");
      }
    }
  };

  const togglePasswordVisibility = (inputId, iconId) => {
    setShowPassword((prev) => !prev); // This updates the React state
    const passwordInput = document.getElementById(inputId);
    const icon = document.getElementById(iconId);
    if (passwordInput) {
      if (passwordInput.type === "password") {
        passwordInput.type = "text";
        return icon?.classList?.replace("fa-eye-slash", "fa-eye");
      } else {
        passwordInput.type = "password";
        return icon?.classList?.replace("fa-eye", "fa-eye-slash");
      }
    } else {
      console.error(`Input element with id "${inputId}" not found.`);
    }
  };

  const preventSpaceKey = (event) => {
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  };
  const handleRecaptchaChange = (token) => {
    setGoogleRecaptchaToken(token);
    handleActiveLoginButton(formValues.username, formValues.password, token);
  };

  const handleActiveLoginButton = (username, password, recaptchaToken) => {
    const isValid = username && password && recaptchaToken;
    setIsButtonDisabled(!isValid);
  };

  return (
    <>
      <LanguageSelect />
      {isCode && <Box className="please-wait">{t("Loading...")}</Box>}
      <Grid className="login-parent-div">
        <Grid className="login-child-div">
          {dynamicLogo && (
            <Box
              component="img"
              id="login-img-learn"
              className="login-logo"
              src={dynamicLogo}
              alt="Learnify"
            />
          )}
        </Grid>
        {!isOnline && (
          <Box className="form-group error-msg" style={{ display: "block" }}>
            {t("No internet connection!")}
          </Box>
        )}
        {microsoftLoginError && (
          <Box className="form-group error-msg" style={{ display: "block" }}>
            {microsoftLoginError}
          </Box>
        )}
        <Box className="form-group error-msg" id="deactivate-error"></Box>
        {!subdomainName && (
          // domain verification screen
          <Grid className="login-right-side-box" sx={{ paddingTop: '15px' }}>
            <Box >
            </Box>
            <Box className="verify-domain" style={{ color: `${bgColor}` }}>
              {t("Verify Domain")}
            </Box>
            <Box className="form-group error-msg" id="domain-name-error"></Box>
            <Box
              component="form"
              id="form-login"
              name="loginForm"
              className="form-input-data form-horizontal"
              onSubmit={handleDomainVerify}
              method="post"
            >
              <Box>
                <Box className="mdc-text-field mdc-text-field--outlined email-field">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                      gap: "8px",
                      justifyContent: "center",
                    }}
                  >
                    <Input
                      type="text"
                      value={formValues.domainname}
                      className="domain-input-box input-box required_text"
                      id="domainField"
                      autoComplete="off"
                      placeholder={t("Domain name")}
                      onChange={(e) => handleDomainName(e)}
                      onKeyDown={preventSpaceKey}
                    />
                    <Box className="domain-name">.{urlDomain}</Box>
                  </Box>
                </Box>
                <Box className="help-block with-errors"></Box>
              </Box>
              <Box className="parent-login-button-div change-domain-name-submit-btn">
                <Button
                  type="submit"
                  id="changeCredentialBtn"
                  className={`login-new-btn ${formValues?.domainname ? "" : "disabled-btn"
                    }`}
                  style={{
                    backgroundColor: `${bgColor}`,
                    color: `${textColor}`,
                  }}
                  disabled={!formValues?.domainname}
                >
                  {t("Verify")}
                </Button>
              </Box>
            </Box>
          </Grid>
        )}
        {subdomainName && (
          <Grid className="login-right-side-box" sx={{ paddingTop: '15px' }}>
            <Box className="login-title" style={{ color: `${bgColor}` }}>
              {t("LOGIN")}
            </Box>
            <Box
              className="form-group error-msg"
              id="reset-credential-error"
            ></Box>
            <Box
              component="form"
              id="form-login"
              name="loginForm"
              className="form-horizontal"
              onSubmit={handleLogin}
              method="post"
            >
              <Box>
                {showCountryCode ? (
                  <Box sx={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                      <Box className="mdc-text-field mdc-text-field--outlined" sx={{ width: "150px" }}>
                      <InputLabel
                        style={{ color: bgColor, padding: "2px" }}
                        className="mdc-text-field__label"
                      >
                        {t("Code")}
                      </InputLabel>
                      <Select
                        value={countryCode}
                        onChange={(e) => {
                          setCountryCode(e.target.value);
                          document.getElementById("changeCredentialBtn")?.removeAttribute("disabled");
                        }}
                        className="input-box"
                        style={{ width: "100%" }}
                      >
                        {countryCodes.map((country) => (
                          <MenuItem key={country.dialCode} value={country.dialCode}>
                            {country.display}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    <Box className="mdc-text-field mdc-text-field--outlined email-field" sx={{ flex: 1 }}>
                      <Box className="mdc-notched-outline__notch">
                        <InputLabel
                          style={{ color: bgColor, padding: "2px" }}
                          className="mdc-text-field__label"
                          htmlFor="loginEmail"
                        >
                          {t("Mobile No.")}
                        </InputLabel>
                      </Box>
                      <Input
                        type="text"
                        value={formValues.username}
                        className="input-box required_text"
                        id="loginEmail"
                        autoComplete="off"
                        placeholder={t("Mobile No.")}
                        onChange={handleEmailChange}
                        onBlur={handleEmailBlur}
                        onKeyDown={preventSpaceKey}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Box className="mdc-text-field mdc-text-field--outlined email-field">
                    <Box className="mdc-notched-outline__notch">
                      <InputLabel
                        style={{ color: bgColor, padding: "2px" }}
                        className="mdc-text-field__label"
                        htmlFor="loginEmail"
                      >
                        {t("Email/Mobile No.")}
                      </InputLabel>
                    </Box>
                    <Input
                      type="text"
                      value={formValues.username}
                      className="input-box required_text"
                      id="loginEmail"
                      autoComplete="off"
                      placeholder={t("Email/Mobile No.")}
                      onChange={handleEmailChange}
                      onBlur={handleEmailBlur}
                      onKeyDown={preventSpaceKey}
                    />
                  </Box>
                )}
                <Box className="help-block with-errors"></Box>
              </Box>
              <Box style={{ position: "relative" }}>
                <Box className="mdc-text-field mdc-text-field--outlined removeTopGap">
                  <InputLabel
                    style={{ color: bgColor, padding: "2px" }}
                    className="mdc-text-field__label"
                    htmlFor="loginPassword"
                  >
                    {t("Password")}
                  </InputLabel>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={formValues.password}
                    className="input-box required_text"
                    id="loginPassword"
                    autoComplete="off"
                    placeholder={t("Password")}
                    onChange={handlePasswordChange}
                    onKeyDown={preventSpaceKey}
                  />
                  <Box className="mdc-notched-outline">
                    <Box className="mdc-notched-outline__leading"></Box>
                    <Box className="mdc-notched-outline__trailing"></Box>
                  </Box>
                  <Icon
                    className="fa fa-eye-slash toggle-password-icon"
                    id="toggleLoginPassword"
                    onClick={() =>
                      togglePasswordVisibility(
                        "loginPassword",
                        "toggleLoginPassword"
                      )
                    }
                  ></Icon>
                </Box>
                <Box className="help-block with-errors"></Box>
              </Box>
              <Box className="login-forgot-password-div">
                <Link
                  id="forgot-password"
                  onClick={handleForgotPassword}
                  className="login-forgot-password-text"
                  style={{ color: bgColor }}
                >
                  {t("Forgot Password")}
                </Link>
              </Box>
              {googleRecaptchaToggle && (
                <ReCAPTCHA
                  id="captchaContainer"
                  className="g-recaptcha"
                  sitekey={googleRecaptchaSiteKey}
                  onChange={handleRecaptchaChange}
                />
              )}
              <Box className="parent-login-button-div">
                <Button
                  type="submit"
                  id="changeCredentialBtn"
                  className={`login-new-btn ${isButtonDisabled ? "disabled-btn" : ""
                    }`}
                  style={{
                    backgroundColor: `${bgColor}`,
                    color: `${textColor}`,
                  }}
                  disabled={isButtonDisabled} // Add the disabled attribute
                >
                  {t("LOGIN")}
                </Button>
                {microsoftLoginSiteKey && (
                  <Button
                    onClick={handleMicrosoftLogin}
                    className="login-microsoft-div microsoft-login-btn"
                    style={{
                      backgroundColor: `${bgColor}`,
                      color: `${textColor}`,
                    }}
                  >
                    <MicrosoftIcon
                      className="login-microsoft-button-icon"
                      alt="microsoft logo"
                    />
                    {t("Sign in with Microsoft")}
                  </Button>
                )}
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Login;
